import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { config, encodeBase64RequestBody, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const UserDetail = () => {
  const { user_keyid } = useParams();
  const [user, setUser] = useState(null);
  const [attainments, setAttainments] = useState(null);
  const [attainmentUser, setAttainmentUser] = useState(null);
  const [totalTargetIDR, setTotalTargetIDR] = useState(0);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const navigate = useNavigate();

  useEffect(() => {
    getUser();
    getAttainments();
    getAttainmentUser();
  }, []);

  const getUser = async () => {
    try {
      const requestUser = {
        "user_keyid": user_keyid
      };
      const fetchUser = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUser)
      });
      const responseUser = await fetchUser.json();
      if (responseUser.status === 200) {
        setUser(responseUser.data[0]);
      } else {
        alert(responseUser.message);
      }
    } catch (error) {
      console.error('Error in getUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getAttainments = async () => {
    try {
      const requestAttainments = {
        "created_by": user_keyid,
        "target_year": format(new Date(), 'yyyy'),
        "attainment_status": "Approved"
      };
      const fetchAttainments = await jwtFetch(config.ENDPOINT + 'get/attainment', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestAttainments)
      });
      const responseAttainments = await fetchAttainments.json();
      if (responseAttainments.status === 200) {
        setAttainments(responseAttainments.data);
      } else {
        alert(responseAttainments.message);
      }
    } catch (error) {
      console.error('Error in getAttainments:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getAttainmentUser = async () => {
    try {
      const requestAttainmentUser = {
        "assigned_to": user_keyid,
        "target_year": format(new Date(), 'yyyy')
      };
      const fetchAttainmentUser = await jwtFetch(config.ENDPOINT + 'get/attainment_user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestAttainmentUser)
      });
      const responseAttainmentUser = await fetchAttainmentUser.json();
      if (responseAttainmentUser.status === 200) {
        setAttainmentUser(responseAttainmentUser.data);
        setTotalTargetIDR(responseAttainmentUser.data.reduce((sum, a) => sum + (numberFormat(a.target_amount) || 0), 0));
      } else {
        alert(responseAttainmentUser.message);
      }
    } catch (error) {
      console.error('Error in getAttainmentUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getAttainmentTotal = (quarter) => {
    if (!attainments) return 0;
    return attainments
      .filter(a => a.target_quarter === quarter)
      .reduce((sum, a) => sum + (numberFormat(a.attainment_total) || 0), 0);
  };

  const totalAttainmentIDR = [1, 2, 3, 4].reduce((sum, q) => sum + getAttainmentTotal(q), 0);

  const getQuarterTarget = (quarter) => {
    if (!attainmentUser) return 0;
    const target = attainmentUser.find(a => a.target_quarter === quarter);
    return numberFormat(target?.target_amount) || 0;
  };

  const getProgress = (quarter) => {
    const target = getQuarterTarget(quarter);
    if (!target) return 0;
    const attained = getAttainmentTotal(quarter);
    return Number(((attained / target) * 100).toFixed(3));
  };

  const totalProgress = totalTargetIDR
    ? Number(((totalAttainmentIDR / totalTargetIDR) * 100).toFixed(3))
    : 0;

  return (
    <div id="user-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="user" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> User Detail</div>
                    {(user && crmUser.user_level !== 'View') && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/user/edit/' + user.user_keyid}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {user ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="sticky-top">
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Name</div>
                            <div className="col-md-8">{user.full_name}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Email</div>
                            <div className="col-md-8">{user.email_address}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Department</div>
                            <div className="col-md-8">{user.user_department}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Role</div>
                            <div className="col-md-8">{user.user_role_division}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Position</div>
                            <div className="col-md-8">{user.user_position}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Type</div>
                            <div className="col-md-8">{user.user_level}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Join Date</div>
                            <div className="col-md-8">{user.joined_date ? format(new Date(user.joined_date), "d MMMM yyyy") : ''}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Status</div>
                            <div className="col-md-8"><span className={"badge bg-" + (user.user_active === 'Active' ? 'success' : 'danger')}>{user.user_active}</span></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card mb-4">
                          <div className="card-body">
                            <div className="fs-18 mb-3">Approval</div>
                            <div className="row align-items-baseline mb-2">
                              <div className="col-md-4 text-secondary">Level 1</div>
                              <div className="col-md-8">
                                {user.approval_1 && (
                                  <div className="card">
                                    <div className="card-body">
                                      <p className="mb-0"><i className="bi bi-person me-2" /> {user.approval_1_name}</p>
                                      <p className="mb-0"><i className="bi bi-envelope me-2" /> {user.approval_1_email}</p>
                                      <p className="mb-0"><i className="bi bi-building me-2" /> {user.approval_1_department}</p>
                                      <p className="mb-0"><i className="bi bi-suitcase-lg me-2" /> {user.approval_1_role}</p>
                                      <p className="mb-0"><i className="bi bi-person-badge me-2" /> {user.approval_1_position}</p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="row align-items-baseline mb-2">
                              <div className="col-md-4 text-secondary">Level 2</div>
                              <div className="col-md-8">
                                {user.approval_2 && (
                                  <div className="card">
                                    <div className="card-body">
                                      <p className="mb-0"><i className="bi bi-person me-2" /> {user.approval_2_name}</p>
                                      <p className="mb-0"><i className="bi bi-envelope me-2" /> {user.approval_2_email}</p>
                                      <p className="mb-0"><i className="bi bi-building me-2" /> {user.approval_2_department}</p>
                                      <p className="mb-0"><i className="bi bi-suitcase-lg me-2" /> {user.approval_2_role}</p>
                                      <p className="mb-0"><i className="bi bi-person-badge me-2" /> {user.approval_2_position}</p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {attainmentUser && user.user_department === 'Sales' && user.user_level === 'User' && (
                          <div className="card mb-4">
                            <div className="card-body">
                              <div className="fs-18 mb-3">Target</div>
                              {/* <div className="row align-items-baseline mb-2">
                                <div className="col-md-4 text-secondary">Exchange Rate</div>
                                <div className="col-md-8">1 USD <i className="bi bi-arrow-right mx-1"/> {priceFormat(attainmentUser[0]?.target_exchange_rate, 'IDR')}</div>
                              </div> */}
                              <div className="table-responsive">
                                <table className="table table-hover bordered">
                                  <thead>
                                    <tr>
                                      <th className="bg-gold text-center">Quarter</th>
                                      <th className="bg-gold text-end">Target</th>
                                      <th className="bg-gold text-end">Attainment</th>
                                      <th className="bg-gold text-end">Progress</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td valign="middle" className="text-center">Q1 {format(new Date(), 'yyyy')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(attainmentUser[0]?.target_amount, 'IDR')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(getAttainmentTotal(1), 'IDR')}</td>
                                      <td valign="middle" className="text-end">{getProgress(1).toFixed(3)}%</td>
                                    </tr>
                                    <tr>
                                      <td valign="middle" className="text-center">Q2 {format(new Date(), 'yyyy')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(attainmentUser[1]?.target_amount, 'IDR')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(getAttainmentTotal(2), 'IDR')}</td>
                                      <td valign="middle" className="text-end">{getProgress(2).toFixed(3)}%</td>
                                    </tr>
                                    <tr>
                                      <td valign="middle" className="text-center">Q3 {format(new Date(), 'yyyy')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(attainmentUser[2]?.target_amount, 'IDR')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(getAttainmentTotal(3), 'IDR')}</td>
                                      <td valign="middle" className="text-end">{getProgress(3).toFixed(3)}%</td>
                                    </tr>
                                    <tr>
                                      <td valign="middle" className="text-center">Q4 {format(new Date(), 'yyyy')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(attainmentUser[3]?.target_amount, 'IDR')}</td>
                                      <td valign="middle" className="text-end">{priceFormat(getAttainmentTotal(4), 'IDR')}</td>
                                      <td valign="middle" className="text-end">{getProgress(4).toFixed(3)}%</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td valign="middle" className="text-center strong">Total</td>
                                      <td valign="middle" className="text-end strong">{priceFormat(totalTargetIDR, 'IDR')}</td>
                                      <td valign="middle" className="text-end strong">{priceFormat(totalAttainmentIDR, 'IDR')}</td>
                                      <td valign="middle" className="text-end strong">{totalProgress.toFixed(3)}%</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <p>No user data</p>
                  )}
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;


